import { render, staticRenderFns } from "./OrdersStatusCard.vue?vue&type=template&id=52c42c7a&scoped=true&"
import script from "./OrdersStatusCard.vue?vue&type=script&lang=js&"
export * from "./OrdersStatusCard.vue?vue&type=script&lang=js&"
import style0 from "./OrdersStatusCard.vue?vue&type=style&index=0&id=52c42c7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c42c7a",
  null
  
)

export default component.exports